// PlaceOrderDrawer.jsx
import { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  TextField,
  Button,
  InputLabel,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OrderConfirmedDrawer from "./OrderConfirmedDrawer";
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@emotion/react";
import { commonServices } from "../../Services/commonServices";
import { apiHandler, widthData, textFormatter, LoaderFun, ErrLoaderOff, currencyFormatter } from "@shared/Functions/apiHandler";
import MiniLoader from "@shared/Components/miniLoader";
import { useDrawerOpenFun } from "../../Context/modelContext";
import { useCheckLogin } from "../../utils/functions";

export default function PlaceOrderDrawer({
  open,
  stationId,
  onClose,
  selectedProducts
}) {

  const theme = useTheme();
  const classes = pageStyles(theme);
  // custom hook for check login
  const checkLogin = useCheckLogin();
  const [productDetails, setProductDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [stationDetails, setStationDetails] = useState({});
  const [confirmOrderDrawer, setConfirmOrderDrawer] = useState(false);
  const [payload, setPayload] = useState({});
  const [calculatedPrice, setCalculatedPrice] = useState([]);
  const { location } = useDrawerOpenFun();

  const priceChange = (e, product) => {
    const value = e.target.value.replace(/\D/g, ""); // keep only digits
    setProductDetails((prev) => {
      return prev.map((item) => {
        if (item.productInfo.productId === product.productId) {
          return { ...item, amount: value };
        }
        return item;
      });
    })

  }

  const getProductDetails = async () => {
    setLoader(true);
    let selectProductData = [];
    for (let i = 0; i < selectedProducts.length; i++) {
      const productId = selectedProducts[i].productId;
      const res = await commonServices.productInfo(productId);
      if (res?.status === 200) {
        // let amount = res?.data?.data?.productInfo?.minOrder * res?.data?.data?.productInfo?.price || 0;
        let amount = 0;
        selectProductData.push({ ...res?.data?.data, amount });
      }
    }
    setProductDetails(selectProductData);
    if (stationId) {
      // { id: vendorId, lat: location.lat, lng: location.lng }
      const res = await commonServices.vendorInfo({ id: stationId, lat: location.lat, lng: location.lng });
      apiHandler(res);
      LoaderFun(res, setLoader);
      ErrLoaderOff(res, setLoader);
      if (res?.status === 200) {
        setStationDetails(res?.data?.data);
      }
    }

  }

  const checkout = async () => {
    let purchaseProducts = [];

    for (let i = 0; i < productDetails.length; i++) {
      const product = productDetails[i];
      const productType = product?.productInfo?.productType;
      const amount = Number(product?.amount);
      const price = product?.productInfo?.price;
      const minOrder = product?.productInfo?.minOrder;
      const purchaseAmount = minOrder * price;
      const orderQty = amount / price;
      const stock = product?.productInfo?.stock;

      // ✅ Validation only for productType === 1
      if (productType === 1 && purchaseAmount > amount) {
        alert(
          `Minimum order quantity for ${product?.productInfo?.name} is ${minOrder} ${product?.productInfo?.measurementName}`
        );
        return false;
      }

      if (productType === 1 && stock < orderQty) {
        alert(
          `Available Stock for ${product?.productInfo?.name} is ${stock} ${product?.productInfo?.measurementName}`
        );
        return false;
      }

      // ✅ Add every product to the final data
      purchaseProducts.push({
        productId: product?.productInfo?.productId,
        qty: amount ? amount : 1,
      });
    }

    const payload = {
      addressId: 1,
      purchaseProducts,
      deliveryType: 2, // 1 - Delivery, 2 - Pickup
      "redeemPoints": false,
    };

    setPayload(payload);
    setConfirmOrderDrawer(true);

  }

  useEffect(() => {
    getProductDetails()
  }, [open]);

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: widthData,
          },
        }}
      >
        {loader ? <MiniLoader /> :
          <Box sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
            <Box sx={classes.flex_c}>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>

              <Typography>
                Order-Self Pickup
              </Typography>
            </Box>

            <Paper variant="outlined" sx={classes.paperDiv}>
              <Box sx={classes.flex_c} >
                <Box component="img" src={stationDetails?.stationDetails?.imageUrl} variant="rounded" sx={classes.fuelIcon2} />
                <Box>
                  <Typography sx={classes.darkTextsmd500}> {stationDetails?.stationDetails?.name} </Typography>
                  <Typography sx={classes.greyTextsmd}> {textFormatter(stationDetails?.stationDetails?.address, 35)} </Typography>
                </Box>
              </Box>
            </Paper>

            {productDetails.length > 0 && productDetails?.map((data, index) => {
              return (
                <>

                  <Paper variant="outlined" sx={classes.paperDiv} key={index}>
                    <Box sx={classes.flex_c} >
                      <Box component="img" src={data?.productInfo?.imageUrl} variant="rounded" sx={classes.fuelIcon2} />
                      <Box>
                        <Typography sx={{ fontWeight: 700 }}>{data?.productInfo?.name}</Typography>
                        {data?.productInfo?.productType === 1 &&
                          <InputLabel sx={classes.darkTextSmall}> Min Order Qty: {data?.productInfo?.minOrder} {data?.productInfo?.measurementName} </InputLabel>}

                        {data?.productInfo?.productType === 1 &&
                          <InputLabel sx={classes.darkTextSmall}> Price: {currencyFormatter()}{data?.productInfo?.price} / {data?.productInfo?.measurementName} </InputLabel>}

                        {data?.productInfo?.productType === 2 &&
                          <InputLabel sx={classes.darkTextSmall}> Price: {currencyFormatter()}{data?.productInfo?.price} </InputLabel>}
                      </Box>
                    </Box>


                    {/* Amount */}
                    {data?.productInfo?.purchaseType === 1 &&
                      <>
                        <Typography sx={{ ...classes.darkTextsmd500, mt: 2 }}>
                          Enter Amount
                        </Typography>

                        <TextField
                          placeholder="₦0"
                          value={data?.amount === 0 ? "" : data?.amount}
                          onChange={(e) => { priceChange(e, data?.productInfo) }}
                          size="small"
                          fullWidth
                          sx={{ mb: 1, mt: 0.5 }}
                        />

                        {data?.amount > 0 && <Typography sx={classes.lightTextsmd}>
                          You'll get {(data?.amount / data?.productInfo?.price).toFixed(2)} L @ ₦{data?.amount}
                        </Typography>}

                      </>}
                  </Paper>
                </>
              );
            })}

            {/* Confirm */}
            <Button
              variant="contained"
              sx={{ my: 2 }}
              onClick={()=>{checkLogin(()=>{checkout()})}}
            >
              Confirm Order
            </Button>
          </Box>}
      </Drawer>

      {/* Order Confirmed Drawer */}
      <OrderConfirmedDrawer
        open={confirmOrderDrawer}
        onClose={() => setConfirmOrderDrawer(false)}
        payload={payload}
        productList={productDetails}
        calculatedPrice={calculatedPrice}
        setCalculatedPrice={setCalculatedPrice}
        vendorId={stationDetails?.stationDetails?.vendorId}
      />
    </>
  );
}
